<template>
  <a
    :href="shareUrl"
    target="_blank">
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    channel: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    hashtags: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ''
    }
  },

  computed: {
    shareUrl () {
      const baseUrl = CHANNEL_URL[this.channel]

      switch (this.channel) {
        case 'facebook':
          return baseUrl + `?u=${this.url}&title=&description=${this.message}&quote=&hashtag=${this.preparedHashtags}`

        case 'twitter':
          return baseUrl + `?text=${this.message}&url=${this.url}&hashtags=${this.preparedHashtags}`

        case 'linkedIn':
          return baseUrl + `?mini=true&summary=${this.message}&title=&url=${this.url}&hashtags=${this.preparedHashtags}&source=`

        case 'whatsapp':
          const description = this.description ? this.description + '%0D%0A%0D%0A' : ''

          return baseUrl + `?text=${description}${this.url}%0D%0A%0D%0A${this.message}`

        case 'email':
          return baseUrl + `?subject=${this.description}&body=${this.url}%0D%0A%0D%0A${this.message}`
      }
    },

    preparedHashtags () {
      if (this.channel === 'facebook' && this.hashtags.length > 0) {
        return this.hashtags[0]
      }

      return this.hashtags.map(hashtag => hashtag.substring(1))
    }
  }
}

const CHANNEL_URL = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://twitter.com/intent/tweet',
  linkedIn: 'http://www.linkedin.com/shareArticle',
  whatsapp: 'https://wa.me/',
  email: 'mailto:'
}
</script>
